import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Grid, Typography, TextField, Button, Link, CircularProgress } from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";
import { withStyles } from "@material-ui/core/styles";

import { scroller, Element } from 'react-scroll';

import * as PaymentActions from "../../actions/PaymentActions";
import * as AccountActions from "../../actions/AccountActions";

import { asyncCheck, createLead } from "../../utils"
import { validateFields } from "../../utils/models"

import { SCROLL_OFFSET } from "../../constants";

const styles = (theme) => ({
  nextBtn: { margin: "0 0 10px 0", height: "3rem" },
  cartIcon: { color: "white" },
  cartHeader: {
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    gridGap: "6px",
    marginTop: "10px",
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": { fontSize: "1.2em" },
    "& legend": { fontSize: "0.78em" },
  },
})(TextField);

class StepOne extends Component {
  constructor(props) {
    super(props);
    this.state = { goingNextStep: false };

    this.timeout = 0;
    this.onChange = this.onChange.bind(this);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.scrollToElement = this.scrollToElement.bind(this);
    this.onAutoFill = this.onAutoFill.bind(this);
    this.getCountryValue = this.getCountryValue.bind(this);
    this.onAutoCompleteBlur = this.onAutoCompleteBlur.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    let { goingNextStep } = this.state;
    let { goingNextStep: prevGoingNextStep } = prevState;

    if (prevGoingNextStep === false && goingNextStep === true) {
      let errorFields = Object.entries(this.props.formErrors).filter(([field, { hasError }]) => hasError && ["firstName", "lastName", "email", "number", "country"].includes(field));
      if (errorFields.length === 0) {
        this.props.actions.nextStep();
        setTimeout(() => this.setState({ goingNextStep: false }), 1000);
      }
      else {
        this.setState({ goingNextStep: false }, () => {
          let elementName = `${errorFields[0][0]}`;
          if (elementName === "country") elementName += `-1`;
          this.scrollToElement(`element-${elementName}`);
        });
      }
    }
  };

  onChange = (event, field, value) => {
    if (event) event.persist();
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.props.accountActions.updateUserAccount(field, value), 100);
  };

  onAutoFill = (event, field, value, prevValue) => {
    if(prevValue === "" || !prevValue) this.props.accountActions.updateUserAccount(field, value);
  }

  onValidateField = (field) => {
    const { userAccount } = this.props;
    const details = userAccount.details || {};

    const values = {};

    if (userAccount[field]) values[field] = userAccount[field];
    else if (details[field]) values[field] = details[field];
    else if (details.address[field]) values[field] = details.address[field];

    this.props.actions.setFormErrors(validateFields([field], values, this.props.formErrors));
  }

  goToNextStep = async () => {
    const { actions, accountActions, countries, userAccount, toggleSignInForm, openSnackbar } = this.props;
    try {
      const details = userAccount.details || {};
      const { email } = userAccount;
      const { firstName, lastName, number, address } = details;
      const { country } = address || {};
      const countryObj = countries.find(c => c.value === country) || null;
      const countryName = countryObj ? countryObj.label : '';
      const fields = ["firstName", "lastName", "email", "number", "country"];
      const values = fields.reduce((final, field) => {
        if (userAccount[field] !== undefined) final[field] = userAccount[field];
        else if (details[field] !== undefined) final[field] = details[field];
        else if (details.address[field] !== undefined) final[field] = details.address[field];

        return final;
      }, {});

      const newFormErrors = validateFields(fields, values, this.props.formErrors);
      const errorFields = Object.entries(newFormErrors).filter(([field, { hasError }]) => hasError && fields.includes(field));

      if (Object.keys(newFormErrors).filter(key => fields.includes(key)).some(key => newFormErrors[key] && newFormErrors[key].hasError)) {
        let elementName = `${errorFields[0][0]}`;
        if (elementName === "country") elementName += `-1`
        this.scrollToElement(`element-${elementName}`);
        return actions.setFormErrors(newFormErrors);
      }

      actions.setLoading(true);

      const result = await asyncCheck("email", email);

      if (result.exist === false) {
        // email does not exist
        const { leadId } = await createLead({ firstName, lastName, country: countryName, email, number });
        if (leadId) accountActions.setLeadId(leadId);
        this.setState({ goingNextStep: true });
        actions.setLoading(false);
      } else if (result.exist === true) {
        actions.setLoading(false);
        openSnackbar({
          type: "warning",
          message: "Email already exists. Please Login.",
          open: true,
          duration: 4000
        });

        setTimeout(() => toggleSignInForm(), 800);
      } else throw new Error('Something went wrong. Please try again');
      
    } catch (error) {
      console.error(error);
      openSnackbar({
        type: "error",
        message: error.message,
        open: true,
      });
      actions.setLoading(false);
    }
  };

  getCountryValue = (label) => {
    if (!label) return "0";
    let country = this.props.countries.find(c => c.label.toLowerCase() === label.toLowerCase().trim());
    return country ? country.value : "0";
  }

  scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  }

  onAutoCompleteBlur = (e, prevValue) => {
    const newValue = this.getCountryValue(e.target.value);
    if(prevValue !== newValue && newValue !== "0" ) {
      this.props.accountActions.updateUserAccount("country", newValue);
      setTimeout(() => this.onValidateField("country"), 200);
    }

    this.props.actions.setFormErrors(validateFields(["country"], {country: newValue}, this.props.formErrors));
  }

  render = () => {
    const { props, onChange, onValidateField, goToNextStep, onAutoFill, getCountryValue, onAutoCompleteBlur } = this;
    const { countries, formErrors, toggleSignInForm, classes, loading, cart, userAccount } = props;

    const userDetails = userAccount.details || {};
    const userAddress = userDetails.address || {};

    const countryValueLabel = countries.find(c => c.value === userDetails.address.country) || null;

    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography
            style={{ display: "inline-block", textAlign: "right", fontSize: "1rem" }}
            variant="body2"
            align="right"
          >
            Already a member?&nbsp;
            <Link onClick={toggleSignInForm} style={{ cursor: "pointer" }}><strong>Sign in</strong></Link>
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ paddingBottom: "8px" }}>
        </Grid>

        <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
          <Typography variant="h4" gutterBottom><strong>New User Details</strong></Typography>
          {cart.length === 0 && !loading ? <Alert variant="outlined" severity="warning">Please add product(s) to your cart.</Alert> : null}
        </Grid>
        <Grid item xs={12}>
          <form noValidate>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="stretch"
              spacing={2}
            >
              <Grid item xs={12}>
                <Element name="element-firstName">
                  <TviTextFiled
                    autoComplete="given-name"
                    required
                    id="firstName"
                    name="firstName"
                    variant="outlined"
                    fullWidth={true}
                    defaultValue={userDetails.firstName || ''}
                    label={`First Name${ formErrors.firstName.hasError ? " (Invalid)" : "" }`}
                    onChange={(e) => onChange(e, "firstName", e.target.value)}
                    onInput={(e) => onAutoFill(e, "firstName", e.target.value, userDetails.firstName || '')}
                    onBlur={() => onValidateField("firstName")}
                    error={formErrors.firstName.hasError}
                    helperText={ formErrors.firstName.hasError ? formErrors.firstName.errorMessage : ""}
                    
                  />
                </Element>
              </Grid>
              <Grid item xs={12}>
                <Element name="element-lastName">
                  <TviTextFiled
                    autoComplete="family-name"
                    required
                    id="lastName"
                    name="lastName"
                    fullWidth={true}
                    variant="outlined"
                    label={`Last Name${formErrors.lastName.hasError ? " (Invalid)" : ""}`}
                    defaultValue={userDetails.lastName || ''}
                    onChange={(e) => onChange(e, "lastName", e.target.value)}
                    onInput={(e) => onAutoFill(e, "lastName", e.target.value, userDetails.lastName || '')}
                    onBlur={() => onValidateField("lastName")}
                    error={formErrors.lastName.hasError}
                    helperText={formErrors.lastName.hasError ? formErrors.lastName.errorMessage : ""}
                  />
                </Element>
              </Grid>
              <Grid item xs={12}>
                <Element name="element-email">
                  <TviTextFiled
                    autoComplete="email"
                    required
                    id="email"
                    name="email"
                    defaultValue={userAccount.email}
                    onChange={(e) => onChange(e, "email", e.target.value)}
                    onBlur={() => onValidateField("email")}
                    onInput={(e) => onAutoFill(e, "email", e.target.value, userAccount.email)}
                    label={`Email${formErrors.email.hasError ? " (Invalid)" : ""}`}
                    error={formErrors.email.hasError}
                    helperText={formErrors.email.hasError ? formErrors.email.errorMessage : ""}
                    fullWidth={true}
                    variant="outlined"
                  />
                </Element>
              </Grid>
              <Grid item xs={12}>
                <Element name="element-number">
                  <TviTextFiled
                    autoComplete="tel-local"
                    required
                    id="number"
                    name="number"
                    type="number"
                    defaultValue={userDetails.number || ''}
                    onChange={(e) => onChange(e, "number", e.target.value)}
                    onInput={(e) => onAutoFill(e, "number", e.target.value, userDetails.number || '')}
                    onBlur={() => onValidateField("number")}
                    label={`Phone Number${ formErrors.number.hasError ? " (Invalid)" : "" }`}
                    error={formErrors.number.hasError}
                    helperText={formErrors.number.hasError ? formErrors.number.errorMessage : ""}
                    fullWidth={true}
                    variant="outlined"
                  />

                </Element>
              </Grid>
              <Grid item xs={12}>
                <Element name="element-country-1">
                  <Autocomplete
                    autoComplete={true}
                    autoHighlight={true}
                    autoSelect={true}
                    value={countryValueLabel}
                    options={countries}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, v, r) => { onChange(e, "country", v ? v.value : "0"); }}
                    renderInput={(params) => (
                      <TviTextFiled
                        {...params}
                        variant="outlined"
                        fullWidth
                        inputProps={{...params.inputProps, "data-hj-allow": true }}
                        required
                        onBlur={(e) => onAutoCompleteBlur(e, (userAddress.country || 0))}
                        onInput={(e) => onAutoFill(e, "country", getCountryValue(e.target.value), (userAddress.country || 0) === 0 ? "" : " ")}
                        label={`Country Name${ formErrors.country.hasError ? " (Invalid)" : "" }`}
                        error={formErrors.country.hasError}
                        helperText={formErrors.country.hasError ? formErrors.country.errorMessage : ""}
                      />
                    )}
                  />

                </Element>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={goToNextStep}
                  className={classes.nextBtn}
                  disabled={loading || cart.length === 0}
                >
                  {loading ? <CircularProgress size={20} /> : <Typography variant="h5">Next</Typography>}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    );
  };
}

StepOne.propTypes = {};

const mapStateToProps = ({ payment, cartReducer, accountReducer }) => ({
  loading: payment.loading,
  countries: payment.countries,
  formErrors: payment.formErrors,
  cart: cartReducer.cart,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepOne));
